/** First character of each of the first two whitespace-separated words, upper-cased; empty → `?`. */
export function initialsOf(displayName: string): string {
  const initials = displayName
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .slice(0, 2)
    .map((word) => ([...word][0] ?? '').toUpperCase())
    .join('');
  return initials.length > 0 ? initials : '?';
}

/** The shell's avatars (TMMAPP-0151 §A 5, P:80): the first character of the name, upper-cased; empty → `?`. */
export function initialOf(displayName: string): string {
  const first = [...displayName.trim()][0];
  return first === undefined ? '?' : first.toUpperCase();
}

/**
 * The bar's context-line name (prototype: "Charles R."): the first word and the second word's
 * initial (the avatar's two initials, spelled out); a one-word name stays whole. Empty → an empty string.
 */
export function contextNameOf(displayName: string): string {
  const words = displayName
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0);
  const first = words[0];
  if (first === undefined) return '';
  const second = words[1];
  const initial = second === undefined ? '' : ([...second][0] ?? '').toUpperCase();
  return initial.length > 0 ? `${first} ${initial}.` : first;
}
